"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Farm_1 = __importDefault(require("@becrop/components/ClientFarmListView/modules/models/Farm"));
const Dashboard_1 = __importDefault(require("../models/Dashboard"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
class DashboardService {
    constructor(url = '') {
        this.data = new Dashboard_1.default();
        this.url = url;
        this.isLoading = false;
        this.farmData = [];
    }
    async call() {
        await this.fetch();
        await this.fetchFarms();
    }
    async fetch() {
        this.isLoading = true;
        try {
            const request = await fetch(this.url);
            const response = await request.json();
            this.data = new Dashboard_1.default(response);
            // this.data = new Dashboard(this.fake);
        }
        catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    }
    async fetchFarms() {
        this.isLoading = true;
        try {
            const request = await fetch('/farm-quoting/list');
            const response = await request.json();
            const parseResponse = response.map((f) => {
                return {
                    id: f.farm_id,
                    name: f.farm_name,
                    created_at: '',
                    client_name: '',
                    client_code: '',
                    total_fields: -1,
                    total_extension: f.extension.value,
                    preferred_unit: f.extension.unit,
                    gis_fields: [],
                    geodata: '',
                    eBeCrop_compatible: f.eBeCrop_compatible,
                    eBeCrop_ready: f.eBeCrop_ready,
                    quote_status: f.quote_status,
                    gis_area_id: f.gis_area_id,
                    last_completed_project: f.last_completed_project,
                    last_proposal: f.last_proposal,
                    auto_quote: f.auto_quote,
                    crops: f.crops.map((c) => new Crop_1.default({
                        id: c.id,
                        name: c.name,
                        icon: c.logo,
                        color: c.color
                    }))
                };
            });
            this.farmData = parseResponse.map((f) => new Farm_1.default(f));
        }
        catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    }
    get fake() {
        return {
            modulesTasks: [
                {
                    module: 'planner',
                    tasksCount: 12,
                    nextTask: 'Accept the Proposal #124',
                    nextUrl: '/results/map?projectId=2274&areaId=5219',
                },
                {
                    module: 'tracking',
                    tasksCount: 15,
                    nextTask: 'Upload GIS Files for Area Calabassas',
                    nextUrl: '/results/map?projectId=2274&areaId=5219',
                },
                {
                    module: 'results',
                    tasksCount: 0,
                    nextTask: '',
                    nextUrl: '/results/map?projectId=2274&areaId=5219',
                },
            ],
            projects: [
                {
                    type: 'trials',
                    name: 'Treatment #9',
                    date: '2023-10-05 20:59:47',
                    extension: 0,
                    extensionUnit: 'ha',
                    previewData: {
                        resultUrl: '/results/project/1032/summary/trials/740',
                        productType: 'Biostimulant',
                        locationsCount: 3,
                        timesCount: 8,
                        categories: [
                            {
                                name: 'Nutrition',
                                symbol: 'NUT',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Nitrogen',
                                        slug: 'nitrogen',
                                        symbol: 'N',
                                        instances: 1,
                                        rating: 2,
                                    },
                                    {
                                        name: 'Phosphorus',
                                        slug: 'phosphorus',
                                        symbol: 'P',
                                        instances: 2,
                                        rating: 2,
                                    },
                                    {
                                        name: 'Potassium',
                                        slug: 'potassium',
                                        symbol: 'K',
                                        instances: 1,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Hormone Prod. and Stress Adapt.',
                                symbol: 'STR',
                                dimension: 'efficacy',
                                superImprovement: true,
                                metrics: [
                                    {
                                        name: 'Salicylic acid (SA)',
                                        slug: 'salicylic_acid_(_s_a)',
                                        symbol: 'STR',
                                        instances: 2,
                                        rating: 3,
                                    },
                                    {
                                        name: 'Bactericide agents',
                                        slug: 'bactericide_agents',
                                        symbol: 'BIO',
                                        instances: 2,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Biocontrol',
                                symbol: 'BIO',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Bactericide agents',
                                        slug: 'bactericide_agents',
                                        symbol: 'BIO',
                                        instances: 2,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Carbon',
                                symbol: 'C',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Carbon',
                                        slug: 'carbon',
                                        symbol: 'C',
                                        instances: 2,
                                        rating: 1,
                                    },
                                ],
                            },
                        ],
                    },
                    crop: {
                        name: 'Corn, Maize',
                        logo: 'corn',
                        color: '#eebb54',
                    },
                    proposal: {
                        name: 'Gaxy Corn BeCrop Trial for UPL NA Inc.',
                        code: 'CSX-2-230713',
                        id: null,
                    },
                },
                {
                    type: 'trials',
                    name: 'Treatment #11',
                    date: '2023-10-09 08:08:20',
                    extension: 0,
                    extensionUnit: 'ha',
                    previewData: {
                        resultUrl: '/results/project/1032/summary/trials/741',
                        productType: 'Biostimulant',
                        locationsCount: 3,
                        timesCount: 8,
                        categories: [
                            {
                                name: 'Nutrition',
                                symbol: 'NUT',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Nitrogen',
                                        slug: 'nitrogen',
                                        symbol: 'N',
                                        instances: 2,
                                        rating: 3,
                                    },
                                    {
                                        name: 'Phosphorus',
                                        slug: 'phosphorus',
                                        symbol: 'P',
                                        instances: 2,
                                        rating: 2,
                                    },
                                    {
                                        name: 'Potassium',
                                        slug: 'potassium',
                                        symbol: 'K',
                                        instances: 2,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Hormone Prod. and Stress Adapt.',
                                symbol: 'STR',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Salicylic acid (SA)',
                                        slug: 'salicylic_acid_(_s_a)',
                                        symbol: 'STR',
                                        instances: 2,
                                        rating: 3,
                                    },
                                    {
                                        name: 'Nematicide agents',
                                        slug: 'nematicide_agents',
                                        symbol: 'BIO',
                                        instances: 2,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Biocontrol',
                                symbol: 'BIO',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Nematicide agents',
                                        slug: 'nematicide_agents',
                                        symbol: 'BIO',
                                        instances: 2,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Carbon',
                                symbol: 'C',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Carbon',
                                        slug: 'carbon',
                                        symbol: 'C',
                                        instances: 2,
                                        rating: 1,
                                    },
                                ],
                            },
                            {
                                name: 'Biodiversity',
                                symbol: 'SHI',
                                dimension: 'biodiversity',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Soil Quality Index',
                                        slug: 'soil__quality__index',
                                        symbol: 'SHI',
                                        instances: 2,
                                        rating: 2,
                                    },
                                ],
                            },
                        ],
                    },
                    crop: {
                        name: 'Corn, Maize',
                        logo: 'corn',
                        color: '#eebb54',
                    },
                    proposal: {
                        name: 'Gaxy Corn BeCrop Trial for UPL NA Inc.',
                        code: 'CSX-2-230713',
                        id: null,
                    },
                },
                {
                    type: 'trials',
                    name: 'Treatment #6',
                    date: '2023-10-09 08:03:08',
                    extension: 0,
                    extensionUnit: 'ha',
                    previewData: {
                        resultUrl: '/results/project/1032/summary/trials/739',
                        productType: 'Biostimulant',
                        locationsCount: 3,
                        timesCount: 8,
                        categories: [
                            {
                                name: 'Nutrition',
                                symbol: 'NUT',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Nitrogen',
                                        slug: 'nitrogen',
                                        symbol: 'N',
                                        instances: 2,
                                        rating: 2,
                                    },
                                    {
                                        name: 'Inorganic P solubilization',
                                        slug: 'inorganic__p_solubilization',
                                        symbol: 'P',
                                        instances: 1,
                                        rating: 2,
                                    },
                                    {
                                        name: 'Potassium solubilization',
                                        slug: 'potassium_solubilization',
                                        symbol: 'K',
                                        instances: 1,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Hormone Prod. and Stress Adapt.',
                                symbol: 'STR',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Abscisic acid (ABA)',
                                        slug: 'abscisic_acid_(_a_b_a)',
                                        symbol: 'STR',
                                        instances: 2,
                                        rating: 3,
                                    },
                                    {
                                        name: 'Bactericide agents',
                                        slug: 'bactericide_agents',
                                        symbol: 'BIO',
                                        instances: 2,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Biocontrol',
                                symbol: 'BIO',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Bactericide agents',
                                        slug: 'bactericide_agents',
                                        symbol: 'BIO',
                                        instances: 2,
                                        rating: 2,
                                    },
                                ],
                            },
                            {
                                name: 'Carbon',
                                symbol: 'C',
                                dimension: 'efficacy',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Carbon',
                                        slug: 'carbon',
                                        symbol: 'C',
                                        instances: 1,
                                        rating: 1,
                                    },
                                ],
                            },
                            {
                                name: 'Biodiversity',
                                symbol: 'SHI',
                                dimension: 'biodiversity',
                                superImprovement: false,
                                metrics: [
                                    {
                                        name: 'Soil Quality Index',
                                        slug: 'soil__quality__index',
                                        symbol: 'SHI',
                                        instances: 1,
                                        rating: -2,
                                    },
                                ],
                            },
                        ],
                    },
                    crop: {
                        name: 'Corn, Maize',
                        logo: 'corn',
                        color: '#eebb54',
                    },
                    proposal: {
                        name: 'Gaxy Corn BeCrop Trial for UPL NA Inc.',
                        code: 'CSX-2-230713',
                        id: null,
                    },
                },
            ],
            samples: [
                {
                    crop: {
                        name: 'Grape',
                        logo: 'grape',
                        color: '#743781',
                    },
                    code: 'ZZZMCS',
                    date: '2023-02-13',
                    parcelName: 'Saint Denis Parcel',
                    version: '3.5',
                    reportUrl: '/report/pdf/000C7Z',
                    categories: [
                        {
                            name: 'Nutrition',
                            symbol: 'HLT',
                            metrics: [
                                {
                                    codeName: 'SOGRA6BOT',
                                    name: 'Botrytis bunch rot',
                                    score: 22,
                                    rank: 2,
                                },
                                {
                                    codeName: 'SOGROT',
                                    name: 'Botrytis bunch rot',
                                    score: 92,
                                    rank: 5,
                                },
                            ],
                        },
                        {
                            name: 'Carbon',
                            symbol: 'C',
                            metrics: [
                                {
                                    codeName: 'SANCQE',
                                    name: 'Botrytis bunch rot',
                                    score: 83,
                                    rank: 4,
                                },
                            ],
                        },
                    ],
                },
                {
                    crop: {
                        name: 'Grape',
                        logo: 'grape',
                        color: '#743781',
                    },
                    code: 'AAZMCS',
                    date: '2023-02-13',
                    parcelName: 'Saint Denis Parcel',
                    version: '3.5',
                    reportUrl: '/report/pdf/000C7Z',
                    categories: [
                        {
                            name: 'Nutrition',
                            symbol: 'NUT',
                            metrics: [
                                {
                                    codeName: 'SOGRA6BOT',
                                    name: 'Botrytis bunch rot',
                                    score: 60,
                                    rank: 4,
                                },
                                {
                                    codeName: 'SOGROT',
                                    name: 'Botrytis bunch rot',
                                    score: 66,
                                    rank: 4,
                                },
                            ],
                        },
                        {
                            name: 'Carbon',
                            symbol: 'C',
                            metrics: [
                                {
                                    codeName: 'SANCQE',
                                    name: 'Botrytis bunch rot',
                                    score: 35,
                                    rank: 3,
                                },
                            ],
                        },
                    ],
                },
                {
                    crop: {
                        name: 'Grape',
                        logo: 'grape',
                        color: '#743781',
                    },
                    code: 'NCOMCS',
                    date: '2023-02-13',
                    parcelName: 'Saint Denis Parcel',
                    version: '3.5',
                    reportUrl: '/report/pdf/000C7Z',
                    categories: [
                        {
                            name: 'Nutrition',
                            symbol: 'HLT',
                            metrics: [
                                {
                                    codeName: 'SOGRA6BOT',
                                    name: 'Botrytis bunch rot',
                                    score: 32,
                                    rank: 2,
                                },
                                {
                                    codeName: 'SOGROT',
                                    name: 'Botrytis bunch rot',
                                    score: 18,
                                    rank: 1,
                                },
                            ],
                        },
                        {
                            name: 'Carbon',
                            symbol: 'C',
                            metrics: [
                                {
                                    codeName: 'SANCQE',
                                    name: 'Botrytis bunch rot',
                                    score: 8,
                                    rank: 1,
                                },
                            ],
                        },
                    ],
                },
                {
                    crop: {
                        name: 'Banana',
                        logo: 'banana',
                        color: '#d8af04',
                    },
                    code: 'QZHTLS',
                    date: '2023-02-13',
                    parcelName: 'Saint Denis Parcel',
                    version: '3.5',
                    reportUrl: '/report/pdf/000C7Z',
                    categories: [
                        {
                            name: 'Nutrition',
                            symbol: 'NUT',
                            metrics: [
                                {
                                    codeName: 'SOGRA6BOT',
                                    name: 'Botrytis bunch rot',
                                    score: 81,
                                    rank: 4,
                                },
                                {
                                    codeName: 'SOGROT',
                                    name: 'Botrytis bunch rot',
                                    score: 90,
                                    rank: 5,
                                },
                            ],
                        },
                        {
                            name: 'Carbon',
                            symbol: 'C',
                            metrics: [
                                {
                                    codeName: 'SANCQE',
                                    name: 'Botrytis bunch rot',
                                    score: 99,
                                    rank: 5,
                                },
                            ],
                        },
                    ],
                },
                {
                    crop: {
                        name: 'Agave',
                        logo: 'agave',
                        color: '#42683e',
                    },
                    code: 'GHJKLL',
                    date: '2023-02-13',
                    parcelName: 'Saint Denis Parcel',
                    version: '3.5',
                    reportUrl: '/report/pdf/000C7Z',
                    categories: [
                        {
                            name: 'Nutrition',
                            symbol: 'NUT',
                            metrics: [
                                {
                                    codeName: 'SOGRA6BOT',
                                    name: 'Botrytis bunch rot',
                                    score: 41,
                                    rank: 3,
                                },
                            ],
                        },
                        {
                            name: 'Carbon',
                            symbol: 'C',
                            metrics: [
                                {
                                    codeName: 'SANCQE',
                                    name: 'Botrytis bunch rot',
                                    score: 12,
                                    rank: 1,
                                },
                                {
                                    codeName: 'PWEFMWP',
                                    name: 'Botrytis bunch rot',
                                    score: 46,
                                    rank: 3,
                                },
                            ],
                        },
                    ],
                },
                {
                    crop: {
                        name: 'Agave',
                        logo: 'agave',
                        color: '#42683e',
                    },
                    code: '00ZMCS',
                    date: '2023-02-13',
                    parcelName: 'Saint Denis Parcel',
                    version: '3.5',
                    reportUrl: '/report/pdf/000C7Z',
                    categories: [
                        {
                            name: 'Nutrition',
                            symbol: 'NUT',
                            metrics: [
                                {
                                    codeName: 'SOGRA6BOT',
                                    name: 'Botrytis bunch rot',
                                    score: 43,
                                    rank: 3,
                                },
                            ],
                        },
                        {
                            name: 'Carbon',
                            symbol: 'C',
                            metrics: [
                                {
                                    codeName: 'SANCQE',
                                    name: 'Botrytis bunch rot',
                                    score: 89,
                                    rank: 5,
                                },
                                {
                                    codeName: 'PWEFMWP',
                                    name: 'Botrytis bunch rot',
                                    score: 8,
                                    rank: 1,
                                },
                            ],
                        },
                    ],
                },
                {
                    crop: {
                        name: 'Agave',
                        logo: 'agave',
                        color: '#42683e',
                    },
                    code: 'QWERTY',
                    date: '2026-02-13',
                    parcelName: 'Saint Denis Parcel',
                    version: '2.5',
                    reportUrl: '/report/pdf/000C7Z',
                    categories: [],
                },
            ],
        };
    }
}
exports.default = DashboardService;
